import React from 'react';
import noFergusAccountImage from './no_fergus_account_small.png';

export default class DefaultLogo extends React.Component {
    render() {
        return (
            <div style={{height: '100%', width: '100%', display: 'flex', justifyContent: 'center'}}>
                <img className="fg-company-logo"
                    src={noFergusAccountImage} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/DefaultLogo.js